module.exports = __webpack_public_path__ + "static/media/sence2.57cde21e.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/sence2.png
// module id = 536
// module chunks = 0